(() => {
  if (customElements.get('random-collection-image')) return;

  class RandomCollectionImage extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      // Wait until the element's contents have been inserted.
      requestAnimationFrame(() => {
        if (!this.isConnected || this.initialized) return;

        const template = this.querySelector('[data-random-image-options]');
        const display = this.querySelector('[data-random-image-display]');

        if (!template || !display) return;

        const options = template.content.children;
        if (!options.length) return;

        const index = Math.floor(Math.random() * options.length);
        const chosen = options[index].cloneNode(true);

        display.replaceChildren(chosen);
        this.initialized = true;

        // Match the product-card transition to the chosen image.
        const card = this.closest('product-card');
        const image = chosen.querySelector('img');

        if (card && image && card.hasAttribute('data-product-transition')) {
          const updateTransitionImage = () => {
            card.dataset.featuredMediaUrl = image.currentSrc || image.src;
          };

          updateTransitionImage();
          image.addEventListener('load', updateTransitionImage, { once: true });
        }
      });
    }
  }

  customElements.define('random-collection-image', RandomCollectionImage);
})();
